/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, TextField } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  getTerminatedLabelerReports,
  setSearchInput,
  setTerminatedLabelerReport,
} from '../Store/actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  autoFormateDate,
  tabHighLigther,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';

import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import { REBATE_SELECT } from '../../../../SharedModules/Errors/constantMessageData';
import {
  quarterToDate,
  convertStringDate,
} from '../../../../SharedModules/utilities/dateUtilities';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const TerminatedLabelerRequest = (props) => {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgramValue,
    rebateProgramList: rebateProgramListData,
    fromDateValue,
    searchResult,
  } = useSelector((state) => state?.sharedState?.TerminatedLabelerReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([]);
  const [selectList, setSelectList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [errorList, setErrorList] = React.useState(errors);
  const [isSearchClicked, setSearchClicked] = React.useState(false);

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
    }
  }, [planType]);

  //Resetting error message on input field change
  React.useEffect(()=> {
    dispatch(setSearchInput({ errors: [] }));
  }, [planType, rebateProgram, fromDate])

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  // Highlights the tab if any error
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/terminatedlabeler', true);
    } else {
      tabHighLigther('/terminatedlabeler', false);
    }
  }, [JSON.stringify(errorList)]);

  // function to validate Quarter
  const handleOnBlur = (type, input) => {
    const value = autoFormateDate(input);
    let allErrors = errorList;
    let fromError = [];
    if (type === 'fromDate') {
      setFromDate(value.toUpperCase());
      fromError = validateQuarter(value, 'fromDate', true);
      allErrors = allErrors.filter((error) => error.field !== 'fromDate');
      allErrors = [...allErrors, ...fromError];
    }

    setErrorList(allErrors);
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen

  const handleSearchClick = () => {
    let allErrors = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    const fromError = validateQuarter(fromDate, 'fromDate', true);

    allErrors = [...allErrors, ...fromError];

    setErrorList(allErrors);
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        fromDateValue: fromDate,
        errors: allErrors,
        rebateProgrameName,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        detailObj: {
          rebateProgramValue: rebateProgram,
          fromDateValue: fromDate,
          rebateProgrameName,
          rebateProgramList: rebateProgramListData,
        },
      })
    );

    if (allErrors.length === 0) {
      setSearchClicked(true);
      dispatch(setTerminatedLabelerReport([]));
      dispatch(
        getTerminatedLabelerReports({
          startDate: convertStringDate(quarterToDate(fromDate, 'fromDate')),
          endDate: convertStringDate(quarterToDate(fromDate, 'toDate')),
          rebateProgram: rebateProgram,
        })
      );
    }
  };

  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));

    updateTabs.push({
      navTo: '/terminatedlabelerdisplay',

      value: 'Terminated Labler Display',
    });

    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    // if (props.history) {
    props.history.push({
      pathname: '/terminatedlabelerdisplay',
    });
    dispatch(clearReduxForFilterAndSort('/terminatedlabelerdisplay'));

    // }
  }

  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator parent1="State Reports" parent2="Terminated Labeler" />

      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />

      <div className="tab-body" />
      <div className="row">
        <div className="col-4 frr-two-col-radio">
          <RadioGroupComponent
            data-testid="TerminatedLabeler-plan-type"
            id="filter-plan-by-radio-btn-action"
            labelName="Plan Type"
            required
            optionList={radioList || []}
            defaultValue={planType}
            filterAction={(value) => {
              setPlanType(value);
              setRebateProgram('-1');
              const errors = errorList.filter(
                (error) => error.field !== 'rebateProgram'
              );
              setErrorList([...errors]);
            }}
            className="log-batch-filter-radio frr-checkInvoiceRadio"
          />
        </div>
        <div className="col-4">
          <>
            <Fieldset label="Rebate Program" required>
              <div style={{ marginTop: 18 }}>
                <SelectBoxComponent
                  data-testid="TerminatedLabeler-rebate-program"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Rebate Program"
                  required
                  select
                  selectOne
                  optionList={selectList || []}
                  defaultValue={rebateProgram}
                  filterAction={(value) => {
                    setRebateProgram(value);
                    const errors = errorList.filter(
                      (error) => error.field !== 'rebateProgram'
                    );
                    setErrorList([...errors]);
                  }}
                  isError={
                    errorList.find((error) => error.field === 'rebateProgram')
                      ?.message
                  }
                />
              </div>
            </Fieldset>
          </>
        </div>
        <div className="col-4">
          <Fieldset label="Quarter: " required>
            <div className="form-wrapper p-0 mt-n3">
              <div className="mui-custom-form input-md field-xl">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="From"
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10, id: 'From' }}
                      required
                      name="From"
                      id="From"
                      value={fromDate}
                      error={
                        errorList.filter((error) => error.field === 'fromDate')
                          ?.length > 0
                          ? 'mandate-fields'
                          : ''
                      }
                      data-testid="TerminatedLabeler-from-date"
                      helperText={
                        errorList.find((error) => error.field === 'fromDate')
                          ?.message
                      }
                      className="mandate-fields frr-display-hidden-label"
                      onBlur={(e) => handleOnBlur('fromDate', e.target.value)}
                      onChange={(e) => {
                        setFromDate(e.target.value.toUpperCase());
                        setErrorList([
                          ...errorList.filter(
                            (error) => error.field !== 'fromDate'
                          ),
                        ]);
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </Fieldset>
        </div>
      </div>
      <div className="row" style={{ marginTop: 30 }}>
        <div className="btn-wrapper col-12">
          <Button
            data-testid="TerminatedLabeler-search-btn"
            onClick={handleSearchClick}
            className="btn btn-success btn-search float-right"
          >
            <SVGComponent iconName="Icon-search" /> Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TerminatedLabelerRequest;
